import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianNumber'
})
export class IndianNumberPipe implements PipeTransform {
  transform(value: number | string, ...args: unknown[]): any {
    if (typeof value === 'number' || !isNaN(Number(value))) {
      // Convert to string if it is a number
      value = value.toString();

      // Regex for Indian numbering system
      const lastThree = value.substring(value.length - 3);
      const otherNumbers = value.substring(0, value.length - 3);
      if (otherNumbers !== '') {
        return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
      } else {
        return lastThree; // When number is less than 1000
      }
    }
    return value; // Return the value if it cannot be transformed
  }
}